import React, { useState } from 'react';
import { SHAPES } from '../mock';
import { Pause, Play } from 'lucide-react';

const ShapesCarousel = () => {
  const [paused, setPaused] = useState(false);
  const loop = [...SHAPES, ...SHAPES];

  return (
    <section className="py-20 lg:py-28 bg-[#FFFFFF]">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
        <div className="relative flex items-center justify-center mb-10 md:mb-12">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1a1a1a] font-normal text-center">
            Discover your Shape
          </h2>
          <button
            onClick={() => setPaused(p => !p)}
            aria-label={paused ? 'Resume auto-scroll' : 'Pause auto-scroll'}
            className="hidden lg:flex absolute right-0 w-10 h-10 rounded-full border border-[#1a1a1a] items-center justify-center hover:bg-[#1a1a1a] hover:text-[#FFFFFF] transition-colors"
          >
            {paused ? <Play size={14} strokeWidth={1.4} /> : <Pause size={14} strokeWidth={1.4} />}
          </button>
        </div>
        <div className="overflow-hidden">
          <div className={`flex w-max gap-6 animate-marquee-shapes ${paused ? '[animation-play-state:paused]' : ''}`}>
            {loop.map((s, i) => (
              <a key={i} href="#" className="group flex-shrink-0 w-[140px] lg:w-[160px] text-center">
                <div className="w-full aspect-square bg-[#FFFFFF] rounded-full flex items-center justify-center overflow-hidden transition-all duration-500 group-hover:shadow-lg group-hover:-translate-y-1">
                  <img src={s.img} alt={s.name} className="w-16 h-16 lg:w-20 lg:h-20 object-contain" />
                </div>
                <div className="mt-4 font-serif text-lg text-[#1a1a1a]">{s.name}</div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShapesCarousel;
